import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../../../shared/util/util';
import {trackEvent} from '../../../../../tracking/amplitude/TrackingV2';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../../../../mutations/MutationTypes';
import {
	UpdateBaselineTemplateInput,
	UpdateBaselineTemplateMutation,
} from './__generated__/UpdateBaselineTemplateMutation.graphql';

const mutation = graphql`
	mutation UpdateBaselineTemplateMutation($input: UpdateBaselineTemplateInput!) {
		updateBaselineTemplate(input: $input) {
			baselineTemplate {
				id
				name
			}
			company {
				id
				...BaselineTemplatesList_company
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<UpdateBaselineTemplateInput>,
	onSuccess?: RelayOnCompleted<UpdateBaselineTemplateMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<UpdateBaselineTemplateMutation>(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			if (!errors?.length) {
				trackEvent('Baseline Template', 'Updated');
			}
			onSuccess?.(response, errors);
		},
		onError: onError,
	});
}

export default {commit};
